import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { Observable } from 'rxjs';

// SERVICES
import { AuthService } from '@app/core/auth';
import { Roles } from '@app/modules/roles/interfaces';

@Injectable({
  providedIn: 'root',
})
export class RolesGuard implements CanActivate {
  constructor(
    private authService :AuthService,
    private router :Router,
    private permissionsService :NgxPermissionsService,
  ) {}

  canActivate(
    route :ActivatedRouteSnapshot,
    state :RouterStateSnapshot,
  ) :| Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (
      this.authService.loginUser?.role === Roles.SUPER_ADMIN_CODE ||
      this.permissionsService.getPermission('roles.read')
    ) {
      return true;
    } else {
      this.router.navigate(['/']);

      return false;
    }
  }
}
